import {
  fetchAreaData,
  fetchAreaDataByLevelAndField,
  fetchAreaDataNew,
  createBatchAreas,
  fetchPreviewTree as fetchPreviewTreeApi,
  destroyAreaNode as destroyAreaNodeApi,
  createNestedArea as createNestedAreaApi,
  createBindRules as createBindRulesApi,
  createBindUserRule as createBindUserRuleApi,
  fetchBindRules as fetchBindRulesApi,
  fetchBindNodeRuleList as fetchBindNodeRuleListApi,
  destoryNodeRule as destoryNodeRuleApi,
  fetchBindUserRule as fetchBindUserRuleApi,
  switchBindUserRule as switchBindUserRuleApi,
  fetchRuleObjectList as fetchRuleObjectListApi,
  bindRuleNodes as bindRuleNodesApi,
  batchBindRuleUserList as bindRuleUserListApi,
  fetchRuleObjectUserList as fetchRuleObjectUserListApi,
  cleanAreaCache as cleanAreaCacheApi,
  updateAreaNodeOrder as updateNodeOrderApi,
  toggleNodeEnabled as toggleNodeEnabledApi,
  fetchFieldBindingTable as fetchFieldBindingTableApi,
  destroyBatchAreas as destroyAreasApi,
  getExportAreaUrl as getExportAreaUrlApi,
} from '@vt/apis/lib-ex/v2/area'
import {
  fetchTableData as fetchTableDataApi,
  fetchTableDataEnhance as fetchTableDataEnhanceApi,
  createTbData as createTbDataApi,
  updateTbData as updateTbDataApi,
  fetchObjectIdsAtTable as fetchObjectIdsAtTableApi,
} from '@vt/apis/lib-ex/v2/tables'
import { listToTree, filterLeaf } from '@ow/utils'
import { isArray, head, castArray } from 'lodash-es'
import Base from './base'

export default class Area extends Base {
  constructor(appId, tbNameId, vtProject) {
    super(appId, tbNameId, vtProject)
    this.idFiledName = 'objectId'
    this.dbSpecPrefix = 'tbi_areas'
  }

  fetchAll() {
    return fetchAreaData(this.appId).then(async (data) => {
      this.data = data
      await this.store(data)
      this.scope = 'all'
      return data
    })
  }

  fetchAllByLevelAndField(fields, level = 1) {
    return fetchAreaDataByLevelAndField(this.appId, fields, level).then(
      (data) => {
        return (data || []).filter((v) => castArray(level).includes(v.level))
      }
    )
  }

  fetchEffectiveData() {
    return this.fetchAll().then((data) => {
      return data.filter((v) => !v.isDisableNode)
    })
  }

  // 获取所有有效的数据
  fetchAllEffectiveData() {
    return this.fetchEffectiveData().then((data) => {
      const arr = data.map((v) => {
        return { ...v, id: v.objectId }
      })

      return arr
    })
  }

  fetchTreeData() {
    return this.fetchAll().then((data) => {
      return listToTree(
        data.map((v) => {
          return { ...v, id: v.objectId }
        })
      )
    })
  }

  fetchEffectiveTreeData() {
    return this.fetchAll().then((data) => {
      return listToTree(
        data
          .map((v) => {
            return { ...v, id: v.objectId }
          })
          .filter((v) => !v.isDisableNode)
      )
    })
  }

  // 获取当前用户绑定的点位
  async fetchEffectiveBindTreeData(targetTbId) {
    const bindIds = await fetchObjectIdsAtTableApi(
      this.appId,
      this.tbId,
      targetTbId
    )

    return this.fetchEffectiveData().then((data) => {
      const arr = data.map((v) => {
        return { ...v, id: v.objectId }
      })

      const tree = listToTree(arr)

      const rootIds = tree.map((node) => node.id)

      // 过滤绑定的点位
      // 判断绑定的是父级
      if (
        bindIds?.length > 0 &&
        bindIds.every((id) => {
          return rootIds.includes(id) || !arr.find((v) => v.id === id)
        })
      ) {
        return tree.filter((node) => bindIds.includes(node.id))
      }
      return filterLeaf(tree, bindIds)
    })
  }

  async fetchBindData(targetTbId) {
    const bindIds = await fetchObjectIdsAtTableApi(
      this.appId,
      this.tbId,
      targetTbId
    )

    return this.fetchEffectiveData().then((data) => {
      const arr = data.map((v) => {
        return { ...v, id: v.objectId }
      })

      if (bindIds && bindIds.length) {
        // 父级也被过滤掉了....
        return arr.filter((v) => bindIds.includes(v.id))
      }
      return arr
    })
  }

  afterDataChanged(tbData) {
    this.store(tbData)
    this.dealLazyData(tbData)
  }

  /**
   * 按id获取数据
   * @param {*} id
   * @returns
   */
  async fetchById(id) {
    const datum = await this.fetchByIds(id)

    return isArray(datum) ? head(datum) : null
  }

  fetchAreaDataNew(tbId) {
    return fetchAreaDataNew(this.appId, tbId).then((data) => {
      return data
    })
  }

  addAreas(tag, parentId, title, tbId) {
    return createBatchAreas(this.appId, tbId, tag, parentId, title).then(
      (data) => {
        return data
      }
    )
  }

  /**
   * @private 通过接口获取全部级联数据
   * @param rawParams 参数
   * @param {*} rawParams.filters
   * @param {*} rawParams.sorts
   * @param {*} rawParams.pageSize
   * @param {*} rawParams.pageNum
   * @returns
   */
  fetchTbDataRaw({ filters, sorts = {}, pageSize, pageNum, fields }) {
    const fetchApi = fields ? fetchTableDataEnhanceApi : fetchTableDataApi
    return fetchApi(
      this.appId,
      this.tbId,
      {
        filters,
        sorts,
        fields,
      },
      {
        size: pageSize,
        page: pageNum,
      }
    )
  }

  /**
   * 获取全部级联数据
   * @param params 参数
   * @param {*} rawParams.filters
   * @param {*} rawParams.sorts
   * @param {*} rawParams.pageSize
   * @param {*} rawParams.pageNum
   * @returns listToTree之后的结果
   */
  fetchTbData(params) {
    return this.fetchTbDataRaw(params).then(async (res) => {
      const { tbData, total } = res
      this.total = total
      // this.afterDataChanged(tbData)
      const dealedData = await this.dealLazyData(tbData)
      return dealedData
    })
  }

  /**
   * 添加多级点位的预览
   * @param {*} areaList — 多级点位列表
   * @returns
   */
  fetchPreviewTree(areaList) {
    return fetchPreviewTreeApi(this.appId, areaList).then(async (data) => {
      return listToTree(
        data.map((v) => {
          return { ...v, id: v.objectId }
        })
      )
    })
  }

  /**
   *添加点位数据
   * @param item — 点位数据
   * @returns
   */
  createTbData(item) {
    return createTbDataApi(this.appId, this.tbId, item).then((newItem) => {
      return newItem
    })
  }

  /**
   * 修改点位
   * @param {*} itemId 要修改的数据
   * @returns
   */
  updateTbData(item, cleanCache = true) {
    return updateTbDataApi(this.appId, this.tbId, item).then((updateItem) => {
      if (cleanCache) {
        this.cleanTbDataCache()
      }
      return updateItem
    })
  }

  /**
   * 删除点位
   * @param {*} objectId 要删除的数据id
   * @returns
   */
  destroyTbData(objectId) {
    return destroyAreaNodeApi(this.appId, this.tbId, objectId).then((res) => {
      return res
    })
  }

  /**
   * 添加多级点位
   * @param {*} parentId 父级id,没有可填null
   * @param {*} list 添加的点位数据
   * @returns
   */
  batchCreateTbData(parentId, list) {
    return createNestedAreaApi(this.appId, this.tbId, parentId, list).then(
      (res) => {
        return res
      }
    )
  }

  /**
   * 创建点位绑定指标规则
   * @param {Object} rule 规则参数
   * @param {string} rule.ruleId 规则参数
   * @param {string} rule.ruleName 规则名称
   * @param {string} rule.targetTbId 绑定的表单id
   * @param {*} rule.ruleConfig 绑定用户
   * @returns
   */
  async createBindRule({ ruleId, ruleName, targetTbId, ruleConfig, ruleIds }) {
    let id
    if (!ruleId) {
      try {
        const res = await createBindRulesApi({
          appId: this.appId,
          leaderId: this.tbId,
          createdById: targetTbId,
          name: ruleName,
          bindType: 'tableValue_tableValue',
        })
        id = res.id
      } catch (err) {
        return { success: false, message: '创建失败' }
      }
    } else {
      id = ruleId
    }

    const objectIds = Object.keys(ruleConfig)

    if (!objectIds.length) {
      return { success: true, message: '创建成功' }
    }

    try {
      const toPost = []

      objectIds.forEach((areaId) => {
        const areaCache = ruleIds[areaId] || {}

        ruleConfig[areaId].forEach((followerBindId) => {
          if (areaCache[followerBindId]) {
            areaCache[followerBindId] = null
          } else {
            toPost.push({
              leaderBindId: areaId,
              bindRuleId: id,
              followerId: targetTbId,
              followerBindId,
            })
          }
        })
      })

      // 获取需要删除的id
      const toDelete = Object.values(ruleIds)
        .map(Object.values)
        .flat(1)
        .filter((v) => v)

      if (toPost.length) {
        await bindRuleNodesApi(toPost)
      }

      if (toDelete.length) {
        await destoryNodeRuleApi(toDelete)
      }

      return { success: true, message: '创建成功' }
    } catch (err) {
      return { success: false, message: err.message || '规则绑定指标失败' }
    }
  }

  /**
   * 获取点位绑定指标规则
   * @returns
   */
  async fetchBindRules(targetTbId, page, per) {
    const res = await fetchBindRulesApi({
      appId: this.appId,
      leaderId: this.tbId,
      createdById: targetTbId,
      page,
      per,
    })

    res.content = res.content.map((item) => ({
      ...item,
      createdTime: item.createdAt,
      updatedTime: item.updatedAt,
      ruleName: item.name,
      enable: item.started,
    }))

    return res
  }

  /**
   * 获取表单绑定节点列表
   * @param {*} bindRuleId
   * @returns
   */
  // eslint-disable-next-line
  fetchBindNodeRuleList(bindRuleId) {
    return fetchBindNodeRuleListApi({
      bindRuleId,
    })
  }

  /**
   * 启用/关闭点位绑定指标规则
   * @param {*} id 规则Id
   * @param {boolean} started 开启关闭
   * @returns
   */
  // eslint-disable-next-line
  switchBindRule(id, started) {
    return createBindRulesApi({
      id,
      started,
    })
  }

  /**
   * 获取点位绑定用户规则
   * @param {string} ruleName 规则名称
   * @param {*} targetTbId 绑定的表单id
   * @returns
   */
  fetchBindUserRule(targetTbId, page, size) {
    return fetchBindUserRuleApi(
      this.appId,
      this.tbId,
      targetTbId,
      page,
      size
    ).then((res) => {
      return res
    })
  }

  /**
   * 创建点位绑定用户规则
   * @param {Object} rule 规则参数
   * @param {string} rule.ruleId 规则参数
   * @param {string} rule.ruleName 规则名称
   * @param {string} rule.targetTbId 绑定的表单id
   * @param {*} rule.ruleConfig 绑定用户
   * @returns
   */
  async createBindUserRule({ ruleId, ruleName, targetTbId, ruleConfig }) {
    let id
    if (!ruleId) {
      try {
        const res = await createBindUserRuleApi(
          this.appId,
          this.tbId,
          ruleName,
          targetTbId
        )

        id = res.id
      } catch (err) {
        return { success: false, message: '创建失败' }
      }
    } else {
      id = ruleId
    }

    const objectIds = Object.keys(ruleConfig)

    if (!objectIds.length) {
      return { success: true, message: '创建成功' }
    }

    try {
      await bindRuleUserListApi(this.appId, id, ruleConfig)

      return { success: true, message: '创建成功' }
    } catch (err) {
      return { success: false, message: '规则绑定用户失败' }
    }
  }

  /**
   * 启用/关闭点位绑定用户规则
   * @param {*} appId 项目Id
   * @param {*} ruleId 规则Id
   * @param {boolean} enable 开启关闭
   * @returns
   */
  switchBindUserRule(ruleId, enable) {
    return switchBindUserRuleApi(this.appId, ruleId, enable)
  }

  /**
   * 获取规则下绑定的objectId
   * @param {*} ruleId 规则Id
   * @returns
   */
  fetchRuleObjectList(ruleId) {
    return fetchRuleObjectListApi(this.appId, ruleId)
  }

  /**
   * 获取规则下某个objectId绑定的用户
   * @param {*} ruleId 规则Id
   * @param {*} objectId 绑定对象id
   * @returns
   */
  fetchRuleObjectUserList(ruleId, objectId) {
    return fetchRuleObjectUserListApi(this.appId, ruleId, objectId)
  }

  /**
   * 清除点位缓存
   * @returns
   */
  cleanTbDataCache() {
    return cleanAreaCacheApi(this.appId).then((res) => {
      return res
    })
  }

  /**
   * 修改节点顺序
   * @param {*} objectList 指标对象列表 eg. {object1: 1, object2: 4}
   * @returns
   */
  updateNodeOrder(objectList) {
    return updateNodeOrderApi(this.appId, this.tbId, objectList)
  }

  /**
   * 节点启用禁用
   * @param {*} objectId
   * @param {*} disable
   * @returns
   */
  toggleNodeEnabled({ objectId, disable }) {
    return toggleNodeEnabledApi(this.appId, this.tbId, objectId, disable)
  }

  /**
   * 获取绑定点位的表单
   * @returns
   */
  fetchFieldBindingTable() {
    return fetchFieldBindingTableApi(this.appId, this.tbId)
  }

  /**
   * 获取全部绑定数据
   * @param {*} useInfo
   */
  fetchBindedTableData(useInfo, areaList, includeDeleted = true) {
    const fetchAllData = async (
      page,
      { useTableId, filters, returnSlugs },
      pre = []
    ) => {
      const res = await fetchTableDataApi(
        this.appId,
        useTableId,
        {
          filters,
        },
        { returnSlugs, size: 1000, page }
      )

      const final = pre.concat(res.tbData)

      if (final.length < res.total) {
        return fetchAllData(
          page + 1,
          { useTableId, filters, returnSlugs },
          final
        )
      }

      return final
    }

    return Promise.all(
      useInfo.map(({ useSlugs, useTableId }) => {
        const queries = [
          {
            slug: useSlugs[0],
            value: areaList,
            queryType: ['containArray'],
          },
        ]
        const isFakeDeletedField = this.tbs[useTableId].fields.find(
          (v) => v.slug === 'isFakeDeleted'
        )
        if (!includeDeleted && isFakeDeletedField) {
          queries.push({
            slug: 'isFakeDeleted',
            value: true,
            queryType: ['notEqual'],
          })
        }
        const filters = {
          queries,
          logicType: 'and',
        }
        const returnSlugs = ['objectId', 'tableDataId', ...useSlugs]
        return fetchAllData(0, {
          useTableId,
          filters,
          returnSlugs,
        })
      })
    )
  }

  destroyAreas(queue) {
    return destroyAreasApi(this.appId, this.tbId, 'AREA', queue.flat(1))
  }

  /**
   * 导出点位
   * @param {boolean} obtainDisableNode 是否获取禁用点位
   * @param {boolean} excludeUsed 是否排除上报过的点位
   * @returns
   */
  getExportUrl(obtainDisableNode = false, excludeUsed = false) {
    return getExportAreaUrlApi(this.appId, obtainDisableNode, excludeUsed)
  }
}

Area.modelName = 'area'
